import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const TemplatesList = () => {
  const navigate = useNavigate();
  const [voucherTemplates, setVoucherTemplates] = useState([]);
  const [invoiceTemplates, setInvoiceTemplates] = useState([]);

  const fetchTemplates = async () => {
    try {
      const [voucherRes, invoiceRes, refundRes] = await Promise.all([
        axios.get("/api/templates/voucher"),
        axios.get("/api/templates/invoice"),
        axios.get("/api/templates/refund"),
      ]);
      setVoucherTemplates(voucherRes.data);
      setInvoiceTemplates(invoiceRes.data);
      setRefundTemplates(refundRes.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  const [refundTemplates, setRefundTemplates] = useState([]);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleAddNew = async (category) => {
    const name = prompt(`Enter new ${category} template name:`);
    if (!name) return;
    try {
      const res = await axios.post("/api/templates/", {
        name,
        category,
        is_active: false,
        config: {},
      });
      fetchTemplates();
      navigate(`/dashboard/templates/edit/${res.data.id}`);
    } catch (error) {
      console.error("Error creating template:", error);
      alert("Failed to create template");
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Templates Management</h4>
        </div>

        <div className="card-body p-4">
          {/* Voucher Section */}
          <div className="mb-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold m-0 text-primary">Vouchers</h5>
              <button className="btn btn-sm btn-success" onClick={() => handleAddNew('voucher')}>
                + ADD NEW
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-hover border">
                <thead className="table-light">
                  <tr>
                    <th>VOUCHERS</th>
                    <th width="150" className="text-center">STATUS</th>
                    <th width="120" className="text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {voucherTemplates.length === 0 && (
                    <tr><td colSpan="3" className="text-center py-4">No templates found</td></tr>
                  )}
                  {voucherTemplates.map((item) => (
                    <tr key={item.id}>
                      <td className="align-middle fw-semibold">{item.name}</td>
                      <td className="text-center align-middle">
                        {item.is_active ? 
                          <span className="badge bg-success">ACTIVE</span> : 
                          <span className="badge bg-secondary">INACTIVE</span>
                        }
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => navigate(`/dashboard/templates/edit/${item.id}`)}
                        >
                          Edit Settings
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Invoice Section */}
          <div className="mb-5">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold m-0 text-primary">Invoice & Receipt Templates</h5>
              <button className="btn btn-sm btn-success" onClick={() => handleAddNew('invoice')}>
                + ADD NEW
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-hover border">
                <thead className="table-light">
                  <tr>
                    <th>INVOICE & RECEIPT TEMPLATES</th>
                    <th width="150" className="text-center">STATUS</th>
                    <th width="120" className="text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceTemplates.length === 0 && (
                    <tr><td colSpan="3" className="text-center py-4">No templates found</td></tr>
                  )}
                  {invoiceTemplates.map((item) => (
                    <tr key={item.id}>
                      <td className="align-middle fw-semibold">{item.name}</td>
                      <td className="text-center align-middle">
                        {item.is_active ? 
                          <span className="badge bg-success">ACTIVE</span> : 
                          <span className="badge bg-secondary">INACTIVE</span>
                        }
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => navigate(`/dashboard/templates/edit/${item.id}`)}
                        >
                          Edit Settings
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Refund Section */}
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold m-0 text-primary">Refund Templates</h5>
              <button className="btn btn-sm btn-success" onClick={() => handleAddNew('refund')}>
                + ADD NEW
              </button>
            </div>
            <div className="table-responsive">
              <table className="table table-hover border">
                <thead className="table-light">
                  <tr>
                    <th>REFUND TEMPLATES</th>
                    <th width="150" className="text-center">STATUS</th>
                    <th width="120" className="text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {refundTemplates.length === 0 && (
                    <tr><td colSpan="3" className="text-center py-4">No templates found</td></tr>
                  )}
                  {refundTemplates.map((item) => (
                    <tr key={item.id}>
                      <td className="align-middle fw-semibold">{item.name}</td>
                      <td className="text-center align-middle">
                        {item.is_active ? 
                          <span className="badge bg-success">ACTIVE</span> : 
                          <span className="badge bg-secondary">INACTIVE</span>
                        }
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => navigate(`/dashboard/templates/edit/${item.id}`)}
                        >
                          Edit Settings
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatesList;
